/* ML 10-17-26: product page refresh. Builds Size/Type pills, a quantity stepper and stay-on-page add to cart.
   The theme's original selects and quantity input stay in the form and stay in charge:
   pills set the select and fire its change event, so variant, price, subscription and
   order-limit apps keep working as before. */
(function () {
  if (window.mlProductPage) return;
  window.mlProductPage = true;

  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }

  function buildPills(sel) {
    if (sel.dataset.mlPills) return;
    sel.dataset.mlPills = '1';
    var wrapper = sel.closest('.selector-wrapper');
    var label = wrapper && wrapper.querySelector('label');
    var group = document.createElement('div');
    group.className = 'ml-pills';
    group.setAttribute('role', 'radiogroup');
    if (label) group.setAttribute('aria-label', label.textContent.trim());

    function sync() {
      group.querySelectorAll('.ml-pill').forEach(function (b) {
        var on = b.dataset.value === sel.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(sel.options, function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ml-pill';
      b.setAttribute('role', 'radio');
      b.dataset.value = opt.value;
      b.textContent = opt.textContent.trim();
      if (opt.disabled) b.disabled = true;
      b.addEventListener('click', function () {
        if (sel.value === opt.value) return;
        sel.value = opt.value;
        fire(sel, 'change');
        sync();
      });
      group.appendChild(b);
    });

    sel.addEventListener('change', sync);
    sel.classList.add('ml-sr-only');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    sel.parentNode.insertBefore(group, sel.nextSibling);
    sync();
  }

  function buildStepper(q) {
    if (q.dataset.mlStep) return;
    q.dataset.mlStep = '1';
    var item = q.closest('.product-form__item--quantity') || q.parentNode;
    if (!q.id) q.id = 'ml-qty-input';
    var label = document.createElement('label');
    label.className = 'ml-qty-label';
    label.htmlFor = q.id;
    label.textContent = 'Quantity';
    var box = document.createElement('div');
    box.className = 'ml-qty';

    function btn(text, aria, dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ml-qty__btn';
      b.textContent = text;
      b.setAttribute('aria-label', aria);
      b.addEventListener('click', function () {
        var step = parseInt(q.step, 10) || 1;
        var min = parseInt(q.min, 10) || 1;
        var max = parseInt(q.max, 10);
        var v = (parseInt(q.value, 10) || min) + dir * step;
        if (v < min) v = min;
        if (max && v > max) v = max;
        q.value = v;
        fire(q, 'input');
        fire(q, 'change');
      });
      return b;
    }

    q.parentNode.insertBefore(box, q);
    box.appendChild(btn('−', 'Decrease quantity', -1));
    box.appendChild(q);
    box.appendChild(btn('+', 'Increase quantity', 1));
    item.insertBefore(label, box);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function updateCartCount(n) {
    var link = document.querySelector('a.site-header__cart');
    if (!link) return;
    var count = document.getElementById('CartCount');
    if (!count) {
      count = document.createElement('div');
      count.id = 'CartCount';
      count.className = 'site-header__cart-count';
      count.innerHTML = '<span></span><span class="icon__fallback-text medium-up--hide">items</span>';
      link.appendChild(count);
    }
    count.classList.toggle('hide', n < 1);
    count.firstElementChild.textContent = n;
  }

  /* Add to cart without leaving the page. Sends the same form fields the theme sends today
     (variant, quantity, selling plan, line item properties). Falls back to the normal
     form submit if the browser cannot do it. */
  function setupAjaxAdd(form) {
    if (form.dataset.mlAjax || !window.fetch || !window.FormData) return;
    form.dataset.mlAjax = '1';
    var btn = form.querySelector('[name="add"]');
    if (!btn) return;
    var msg = document.createElement('div');
    msg.className = 'ml-atc-msg';
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    btn.parentNode.appendChild(msg);

    function show(html, isError) {
      msg.innerHTML = html;
      msg.classList.toggle('is-error', !!isError);
      msg.classList.add('is-visible');
    }
    function hide() { msg.classList.remove('is-visible'); }
    form.addEventListener('change', hide);

    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var q = form.querySelector('input[name="quantity"]');
      var qty = parseInt(q && q.value, 10) || 1;
      var max = parseInt(q && q.getAttribute('mm-max'), 10);
      if (max && qty > max) {
        show('This item has a limit of ' + max + ' per order.', true);
        return;
      }
      if (form.reportValidity && !form.reportValidity()) return;

      var data = new FormData(form);
      var variantId = String(data.get('id'));
      btn.disabled = true;
      btn.classList.add('is-loading');
      function done() { btn.disabled = false; btn.classList.remove('is-loading'); }

      var check = max
        ? fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        : Promise.resolve(null);

      check.then(function (cart) {
        if (cart) {
          var inCart = 0;
          cart.items.forEach(function (i) { if (String(i.variant_id) === variantId) inCart += i.quantity; });
          if (inCart + qty > max) {
            show('This item has a limit of ' + max + ' per order. You have ' + inCart + ' in your cart.', true);
            done();
            return;
          }
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, body: j }; });
        }).then(function (res) {
          if (!res.ok) {
            show(esc(res.body.description || res.body.message || 'This item could not be added to your cart.'), true);
            return;
          }
          show('Added to cart. <a href="/cart">View cart</a>');
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) { updateCartCount(c.item_count); })
            .catch(function () {});
        }).then(done, function () {
          done();
          show('Something went wrong. Please try again or <a href="/cart">view your cart</a>.', true);
        });
      }, function () {
        done();
        form.submit();
      });
    });
  }

  function init() {
    var form = document.querySelector('form.product-form-product-template');
    if (!form) return;
    form.classList.add('ml-pp');
    form.querySelectorAll('.selector-wrapper select.single-option-selector').forEach(buildPills);
    var q = form.querySelector('.product-form__item--quantity input[name="quantity"]');
    if (q) buildStepper(q);
    setupAjaxAdd(form);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
